// extracted by mini-css-extract-plugin
module.exports = {"price":"_2hxnD5Lx2ip3InWc1Aertb","outOfStock":"QU8zNhr5kHvXmba3FYMML"};